
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';

const ActivityView = () => {
    const { id } = useParams(); // Get the activityId from the URL
    const [activityDetails, setActivityDetails] = useState(null);
    const [editedActivityDetails, setEditedActivityDetails] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [activeTab, setActiveTab] = useState('activityInfo'); // Define activeTab
    const [activityTypes, setActivityTypes] = useState([]);
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();

    const fetchActivityTypes = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/activity-types`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            setActivityTypes(response.data.data);
        } catch (error) {
            console.error('Error fetching activity types:', error);
        }
    };

    const fetchUsers = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/users`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            setUsers(response.data.users || []);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const fetchActivityDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/activities/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });

            setActivityDetails(response.data.data);
            setEditedActivityDetails(response.data.data); // Set initial details for editing

        } catch (error) {
            console.error('Error fetching activity details:', error);
        }
    };

    useEffect(() => {
        fetchActivityTypes();
        fetchUsers();
        if (id) {
            fetchActivityDetails();
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedActivityDetails((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSave = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            await axios.put(`${backendUrl}/api/activities/${id}`, editedActivityDetails, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });

            setIsEditMode(false); // Exit edit mode after saving
        } catch (error) {
            console.error('Error saving activity details:', error);
        }
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    if (!activityDetails) {
        return <div>Loading...</div>;
    }

    const renderField = (label, name, value, type = 'text', options = []) => {
        // If the field has no value and we're not in edit mode, don't render it
        if (!value && !isEditMode) {
            return null;
        }

        return (
            <div className="col-md-4 mb-3">
                <label className="col-form-label" style={{ fontSize: '13px' }}>{label}</label>
                {type === 'select' ? (
                    <select
                        style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                        className="form-control"
                        name={name}
                        value={value || ''} // Ensure the value is not undefined
                        readOnly={!isEditMode}
                        disabled={!isEditMode} // Disable the dropdown in non-edit mode
                        onChange={handleChange}
                    >
                        <option value="">Select {label}</option>
                        {options.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                ) : (
                    <input
                        style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                        className="form-control"
                        type={type}
                        name={name}
                        value={value || ''} // Ensure the value is not undefined
                        readOnly={!isEditMode}
                        onChange={handleChange}
                    />
                )}
            </div>
        );
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Activity Details</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><Link to={`/lead/details/${activityDetails?.lead_id}`}>
                                            {activityDetails?.lead?.name || "Lead"}
                                        </Link></li>
                                        <li className="breadcrumb-item">
                                            {activityDetails?.subject || "Activity Details"}
                                        </li>
                                        <li className="breadcrumb-item active">Details</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="email-leftbar card">
                                <div className="card-body">
                                    <a
                                        onClick={() => handleTabClick('activityInfo')}
                                        className={`list-group-item list-group-item-action ${activeTab === 'activityInfo' ? 'active-tab' : ''}`}
                                    >
                                        Activity Details
                                    </a>
                                    <div className="button-container">
                                        <button onClick={handleBackClick} className="btn btn-secondary mb-4 back">Back</button>
                                    </div>
                                </div>
                            </div>
                            <div className="email-rightbar">
                                <div className="card">
                                    <div className="card-body">
                                        {activeTab === 'activityInfo' && (
                                            <>
                                                <h4 className="mb-sm-0 font-size-18">Activity Details</h4><br />
                                                <form>
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="row">
                                                                {renderField('Subject', 'subject', editedActivityDetails.subject)}
                                                                {renderField('Assigned To', 'user_id', editedActivityDetails.user_id, 'select',
                                                                    users.map(u => ({ value: u.id, label: u.name }))
                                                                )}
                                                                {renderField('Activity Type', 'activity_type_id', editedActivityDetails.activity_type_id, 'select',
                                                                    activityTypes.map(at => ({ value: at.id, label: at.name }))
                                                                )}
                                                                {renderField('Priority', 'priority', editedActivityDetails.priority, 'select', [
                                                                    { value: 'low', label: 'Low' },
                                                                    { value: 'medium', label: 'Medium' },
                                                                    { value: 'high', label: 'High' },
                                                                ])}
                                                                {renderField('Status', 'status', editedActivityDetails.status, 'select', [
                                                                    { value: 'pending', label: 'Pending' },
                                                                    { value: 'in progress', label: 'In Progress' },
                                                                    { value: 'completed', label: 'Completed' },
                                                                    { value: 'cancelled', label: 'Cancelled' },
                                                                ])}
                                                                {renderField('Notes', 'notes', editedActivityDetails.notes)}
                                                                {renderField('Due Date', 'due_date', editedActivityDetails.due_date, 'date')}
                                                                {renderField('Reminder', 'reminder_at', editedActivityDetails.reminder_at, 'datetime-local')}
                                                            </div>
                                                            <div className="d-flex justify-content-end">
                                                                {isEditMode ? (
                                                                    <button type="button" className="btn btn-secondary" onClick={handleSave}>Save</button>
                                                                ) : (
                                                                    <button type="button" className="btn btn-secondary" onClick={() => setIsEditMode(true)}>Edit</button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActivityView;
